import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import {
  NbThemeModule,
  NbLayoutModule,
  NbSidebarModule,
  NbMenuModule,
  NbSidebarService,
  NbCardModule,
  NbInputModule,
  NbListModule,
  NbSpinnerModule,
  NbWindowModule,
  NbCheckboxModule,
  NbContextMenuModule,
  NbAccordionModule, NbActionsModule, NbButtonModule, NbToggleModule, NbIconModule, NbDialogModule
} from '@nebular/theme';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { TestComponent } from './test/test.component';

import { RouterModule } from '@angular/router';
import {ChartModule} from "angular2-chartjs";
import { HelpersComponent } from './helpers/helpers.component';
import { ChartsComponent } from './helpers/charts/charts.component';
import { D3Component } from './helpers/charts/d3/d3.component';
import { EchartsComponent } from './helpers/charts/echarts/echarts.component';
import {ChartsModule} from "./helpers/charts/charts.module";
import { TelecontactComponent } from './telecontact/telecontact.component';
import {HttpClientModule} from "@angular/common/http";
import { GalleryComponent } from './gallery/gallery.component';
import {FormsModule} from "@angular/forms";
import { CompaniesComponent } from './companies/companies.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ProjectsComponent } from './projects/projects.component';
import { HcpComponent } from './hcp/hcp.component';
import {config} from "rxjs";
import { DialogComponent } from './helpers/dialog/dialog.component';

@NgModule({
  declarations: [
    AppComponent,
    TestComponent,
    HelpersComponent,
    ChartsComponent,
    D3Component,
    EchartsComponent,
    TelecontactComponent,
    GalleryComponent,
    CompaniesComponent,
    ProjectsComponent,
    HcpComponent,
    DialogComponent
  ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        RouterModule,
        HttpClientModule,

        NbThemeModule.forRoot({name: 'default'}),
        NbMenuModule.forRoot(),
        NbWindowModule.forRoot(),
        NbDialogModule.forRoot(),
        NbLayoutModule,
        NbEvaIconsModule,
        NbSidebarModule,
        NbCardModule,
        NbListModule,
        NbInputModule,
        ChartModule,
        ChartsModule,
        FormsModule,
        NbSpinnerModule,
        NgbModule,
        NbCheckboxModule,
        NbContextMenuModule,
        NbAccordionModule,
        NbActionsModule,
        NbButtonModule,
        NbToggleModule,
        NbIconModule
    ],
  providers: [NbSidebarService],
  bootstrap: [AppComponent]
})
export class AppModule { }
